import { CenterLayout } from '@cmr/react-ui-common';
import { Box, Typography } from '@material-ui/core';
import React from 'react';

const Redirector = () => {
  setTimeout(() => {
    window.location.href = process.env.REACT_APP_NEXUS_URL!;
  }, 5000);

  return (
    <CenterLayout>
      <Typography variant='h3'>
        The invoicing tool has been migrated to the new Nexus Portal!
      </Typography>
      <Box mt='25px'>
        <Typography>
          The new portal can be located at{' '}
          <a href={process.env.REACT_APP_NEXUS_URL}>
            {process.env.REACT_APP_NEXUS_URL}
          </a>
          . Please update your bookmarks accordingly.
        </Typography>
      </Box>
    </CenterLayout>
  );
};

export default Redirector;
